const formatTime = function (createtime) {
    const currentDay = new Date();
    const now = Date.parse(currentDay);
    const naturalDay = new Date(
        currentDay.getFullYear(),
        currentDay.getMonth(),
        currentDay.getDate()
    );
    const now_start = Date.parse(naturalDay);
    const prev_start = now_start - 86400000;
    const offset = now - createtime;
    const offset_start = now_start - createtime;
    const createDay = new Date(createtime);
    const content = [];

    if (offset_start <= 0) {
        if (offset < 60000) {
            content[0] = '刚刚';
        } else if (offset >= 60000 && offset < 3600000) {
            content[0] = ~~(offset / 60000);
            content[1] = '分钟前';
        } else if (offset >= 3600000 && offset < 86400000) {
            content[0] = ~~(offset / 3600000);
            content[1] = '小时前';
        }
    } else {
        if (offset < 60000) {
            content[0] = '刚刚';
        } else if (offset >= 60000 && offset < 3600000) {
            content[0] = ('0' + ~~(offset / 60000)).slice(-2);
            content[1] = '分钟前';
        } else if (createtime > prev_start) {
            content[0] = '昨天';
        } else {
            content[0] = ('0' + createDay.getDate()).slice(-2);
            content[1] = ('0' + (createDay.getMonth() + 1)).slice(-2) + '月';
        }
    }
    return content;
};

export const formatCreateTime = function (createTime) {
    const formatStr = formatTime(createTime);
    if (!formatStr[1]) {
        return formatStr[0];
    } else {
        if (formatStr[1].indexOf('月') !== -1) {
            return formatStr[1] + formatStr[0] + '日';
        } else {
            return formatStr[0] + formatStr[1];
        }
    }
};
